import z from 'zod';
import {
  parseStringToBoolean,
  parseStringToNumber,
} from '@r-and-a-shared-ui/utils';

export const pp_accreditationFormContactZodObject = {
  accreditationForm: z.object({
    affiliatedOrganization: z.string().nullable().optional(),
    subCategory: parseStringToNumber,
    jobTitle: z.string().nullable().optional(),
    fullName: z.string().nullable().optional(),
    forename: z.string().nullable().optional(),
    surname: z.string().nullable().optional(),
    dateOfBirth: z.date().nullable().optional(),
    coachType: z.string().nullable().optional(),
    agreeToTermsAndConditions: parseStringToBoolean,
    emailAddress: z.string().nullable().optional(),
    mobile: z.string().nullable().optional(),
    mobileCode: z.string().nullable().optional(),
    accDocumentFile: z.any().nullable().optional(),
    contactImageFile: z.any().nullable().optional(),
    nominatedForDinner: z.boolean().nullable().optional(),
    lockAsReadonly: z.boolean().nullable().optional(),
  }),
  currentChampionshipId: z.string(),
  accreditationFormKontentItemCodename: z.string(),
};
